// extracted by mini-css-extract-plugin
export default {"cls1":"fAccJ2rgL1M6XYtTLYKU","cls2":"FdJhYTzM3vwHkL6gnXQe fAccJ2rgL1M6XYtTLYKU","fade-in":"y0PGpb99mJ21Tiybsd5U"};